/* eslint-disable react/prop-types */
/* eslint-disable camelcase */
import React, {
  useEffect, useCallback, useRef, useState,
} from 'react';
import { PropTypes } from 'prop-types';
import { useDispatch, useSelector } from 'react-redux';

import {
  Table, Select, Modal, Spin, Button, Form,
} from 'antd';
import { debounce } from 'lodash';
import { PlusOutlined } from '@ant-design/icons';

import { MerchantUserColumns } from './Columns';
import { getAllUsers } from '../../redux/actions/Auth';
import { updateMerchantAccount } from '../../redux/actions/Data';

const { Option } = Select;
const formItemLayout = {
  wrapperCol: { span: 16 },
};

const MerchantUsers = ({ merchant }) => {
  const dispatch = useDispatch();
  const [visible, setVisible] = useState(false);
  const [selectedUsers, setselectedUsers] = useState(merchant.merchant_users);
  const { data: userData, loadingUsers } = useSelector(({ auth }) => auth.users);
  const { loadingAuthUser, authUser } = useSelector(({ auth }) => auth);
  const loading = loadingUsers || loadingAuthUser;
  const isMerchant = authUser.role.name.includes('Merchant');

  const form = useRef();

  useEffect(() => {
    dispatch(getAllUsers('', isMerchant));
  }, [dispatch]);

  const userSearch = (search) => {
    const searchFilter = JSON.stringify([
      { full_name: { $regex: search.trim(), $options: 'i' } },
      { first_name: { $regex: search.trim(), $options: 'i' } },
      { last_name: { $regex: search.trim(), $options: 'i' } },
      { email: { $regex: search.trim(), $options: 'i' } },
    ]);
    const searchParams = `filter={"$or": ${searchFilter}}`;
    dispatch(getAllUsers(searchParams, isMerchant));
  };

  const debouncedSearch = useCallback(
    debounce((nextValue) => userSearch(nextValue), 1000),
    [],
  );

  const handleUserSearch = (value) => {
    debouncedSearch(value);
  };

  const removeUser = (record) => {
    const new_merchant_users = merchant.merchant_users.filter((user) => user._id !== record._id);
    dispatch(
      updateMerchantAccount(merchant._id, { ...merchant, merchant_users: new_merchant_users }),
    );
  };

  const handleShowModal = () => {
    if (form.current) {
      form.current.resetFields();
    }
    setVisible(true);
  };

  const handleOk = () => {
    if (form.current) {
      form.current.validateFields().then((values) => {
        dispatch(
          updateMerchantAccount(merchant._id,
            {
              ...merchant,
              merchant_users: values.users.map((userId) => {
                const userObj = userData.find(
                  (element) => element._id === userId,
                );
                const { email, _id, full_name } = userObj;
                return { full_name, email, _id };
              }),
            }),
        );
        setTimeout(() => setVisible(false), 2000);
      });
    }
  };

  const handleCancel = () => {
    setVisible(false);
  };

  const usersOptions = userData && userData
    .map((user) => (<Option key={user._id}>{`${user.full_name} - ${user.email}`}</Option>));

  const tableProps = {
    pagination: false,
    columns: MerchantUserColumns(removeUser),
    dataSource: merchant.merchant_users,
  };

  return (
    (
      <div>
        <div className="gx-d-flex justify-content-center">
          <Button
            icon={<PlusOutlined />}
            type="primary"
            onClick={() => handleShowModal()}
          >
            Add Merchant User
          </Button>
        </div>
        <div>
          <Table className="gx-table-responsive" {...tableProps} />
        </div>
        <Modal
          title="Add merchant user"
          open={visible}
          okText="Add"
          onOk={handleOk}
          onCancel={handleCancel}
          centered
          width={600}
        >
          <Form
            name="merchant-form"
            className="gx-form-row0"
            ref={form}
            {...formItemLayout}
          >
            <Form.Item
              name="users"
              label="Merchant User"
              rules={[
                { required: true, message: 'This input is required!' },
              ]}
            >
              <Select
                mode="multiple"
                showSearch
                value={selectedUsers}
                placeholder="Search for a user by email"
                showArrow={false}
                filterOption={false}
                onSearch={handleUserSearch}
                onChange={(value) => setselectedUsers(value)}
                notFoundContent={loading ? <Spin size="small" /> : 'No User found'}
              >
                {usersOptions}
              </Select>
            </Form.Item>
          </Form>
        </Modal>
      </div>
    )
  );
};

MerchantUsers.propTypes = {
  merchantUsers: PropTypes.arrayOf(
    PropTypes.shape({ id: PropTypes.string, name: PropTypes.string }),
  ),
};

MerchantUsers.defaultProps = {
  merchantUsers: [],
};

export default MerchantUsers;
